import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLeaderboard: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="leaderboard, winner, stats, graph"><path d="M11 6C9.61929 6 8.5 7.11929 8.5 8.5V18H15.5V8.5C15.5 7.11929 14.3807 6 13 6H11Z" fill="currentColor"/><path d="M3 8.5C1.61929 8.5 0.5 9.61929 0.5 11V16C0.5 17.1046 1.39543 18 2.5 18H7V8.5H3Z" fill="currentColor"/><path d="M17 10V18H21.5C22.6046 18 23.5 17.1046 23.5 16V12.5C23.5 11.1193 22.3807 10 21 10H17Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLeaderboard;
